import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@app/shared/utils/common';

interface CooldownViewProps extends HTMLAttributes<HTMLDivElement> {
  isAvailable: boolean;
  formattedLeft: string;
  onClick: () => void;
  className?: string;
  timerClassName?: string;
  children: ReactNode;
}

export const CooldownView = ({
  isAvailable,
  formattedLeft,
  onClick,
  children,
  className,
  timerClassName,
  ...rest
}: CooldownViewProps) => {
  return (
    <div onClick={onClick} {...rest} className={cn('relative cursor-pointer', className)}>
      {!isAvailable && (
        <span
          className={cn(
            'absolute top-1/2 left-1/2 -translate-x-1/2 bg-white text-card -translate-y-1/2 z-10 px-2 rounded',
            timerClassName
          )}
        >
          {formattedLeft}
        </span>
      )}
      <div className={cn(!isAvailable && 'grayscale')}>{children}</div>
    </div>
  );
};
